<template>
    <div class="main theme-light">
        <div v-if="cropperiod_UUID && cropperiod_detail" id="page-top" class="animated fadeIn p-3">

            <div v-if="loading">
                <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
            </div>

            <b-row>
                <b-col cols="12" xl="3" md="4" sm="4">
                    <h4 class="card-title agri-color" v-text="cropperiod_detail.name"></h4>
                    <div class="cropperiod-img cover-bg" alt="cropperiods photo" :style="$tools.style.imgCover( $config.checkURL('cropperiod', cropperiod_detail.pic) )" />

                    <!-- <ButtonFullScreen
                        :target_element_id="undefined"
                        variant="outline-success"
                        set_class="text-right mt-1"
                        set_button_class=""
                    ></ButtonFullScreen> -->
                </b-col>
                <b-col cols="12" xl="9" md="8" sm="8">

                    <b-tabs v-model="tabIndex[0]">

                        <!-- 期作資訊 -->
                        <b-tab class="info-tab" active :title="$t('menu.cropping_season_information')">

                            <b-row>
                                <b-col cols="12">
                                    <!-- 品種 -->
                                    <h5 class="card-subtitle mb-3 agri-color-sub">
                                        <i class="fa fa-leaf block-text"></i>
                                        <div class="block-text">{{ cropperiod_detail.cropinfo.crop_name }} {{ cropperiod_detail.cropinfo.cultivar_name }}</div>
                                    </h5>

                                    <!-- 敘述 -->
                                    <div class="card-subtitle mb-2" v-if="cropperiod_detail.description">
                                        <div class="block-text">{{ cropperiod_detail.description }}</div>
                                    </div>

                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col cols="12" xl="4">

                                    <!-- 時區 -->
                                    <div class="card-subtitle mb-2">
                                        <i class="fa fa-clock-o block-text"></i>
                                        <div class="block-text">{{ $t('menu.timezone') }}:</div>
                                        <div class="block-text">{{ cropperiod_detail.project_timezone }}</div>
                                    </div>

                                    <!-- 開始日期 -->
                                    <div class="card-subtitle mb-2">
                                        <i class="fa fa-calendar block-text"></i>
                                        <div class="block-text">{{ $t('menu.planting_day') }}:</div>
                                        <div class="block-text">{{ cropperiod_detail.start_date }}</div>
                                    </div>

                                    <!-- 結束日期 -->
                                    <div class="card-subtitle mb-2" v-if="cropperiod_detail.end_date">
                                        <i class="fa fa-calendar block-text"></i>
                                        <div class="block-text">{{ $t('menu.end_date') }}:</div>
                                        <div class="block-text">{{ cropperiod_detail.end_date }}</div>
                                    </div>

                                    <!-- 面積 -->
                                    <div class="card-subtitle mb-2" v-if="cropperiod_detail.area || cropperiod_detail.density">
                                        <div class="block-text">
                                            <UnitConvertorArea :area="cropperiod_detail.area" :density="cropperiod_detail.density" defaultUnit="m2" :timezone="cropperiod_detail.project_timezone"
                                                            pageType="cropperiod" selectorType="dropdown"></UnitConvertorArea>
                                        </div>
                                    </div>

                                    <!-- 田區 -->
                                    <div class="card-subtitle mb-2" v-if="cropperiod_detail.farm_field">
                                        <i class="cui-dashboard block-text"></i>
                                        <div class="block-text">{{ $t('n.field') }}:</div>
                                        <div class="block-text">{{ cropperiod_detail.farm_field }}</div>
                                    </div>

                                </b-col>
                                <b-col cols="12" xl="8">

                                    <!-- 種植天數 -->
                                    <div class="emphasis-block" v-if="cropperiod_detail.start_date">
                                        <div class="emphasis-block-title">{{ $t('menu.days_after_planting') }}</div>

                                        <div class="emphasis-block-body"> {{ cropperiod_detail.count_plantingDays }} </div>
                                        {{ $t('u.days') }}
                                    </div>

                                    <!-- 生長階段 -->
                                    <div class="emphasis-block" v-if="showUI.dashboard_stages && cropperiod_detail.stage.current_growth_stage">
                                        <div class="emphasis-block-title">{{ $t('menu.current_growth_stage') }}</div>
                                        <div class="emphasis-block-body">{{ cropperiod_detail.stage.current_growth_stage }} {{ cropperiod_detail.stage.current_percentage }}%</div>
                                    </div>

                                    <!-- 下一個生長階段 -->
                                    <div class="emphasis-block" v-if="showUI.dashboard_stages && cropperiod_detail.stage.next_growth_stage && cropperiod_detail.stage.day_next">
                                        <div class="emphasis-block-title">{{ $t('menu.days_to_next_stage') }}</div>
                                        <div class="emphasis-block-body">{{ cropperiod_detail.stage.next_growth_stage }} {{ daysToNextStage }}</div>
                                        {{ $t('u.days') }}
                                    </div>

                                    <!-- 積溫 -->
                                    <div class="card-subtitle mb-2" v-if="cgpList && showUI.dashboard_stages">

                                        <b-progress :max="cgpData.total_bar" class="mb-3 progressbar-bg">

                                            <template v-for="(cgp, idx) in cgpList">
                                                <!-- Progress Bar 彩色 已完成進度調 -->
                                                <b-progress-bar :key="idx"
                                                                :id="'cgp-' + idx"
                                                                v-if="cgp.period_bar[0] > 0"
                                                                :class="'cgp cgp-'+idx"
                                                                :value="cgp.period_bar[0]">
                                                    {{ cgp.period[0] }}
                                                </b-progress-bar>
                                                <!-- Progress Bar 灰色 未來進度調 -->
                                                <b-progress-bar :key="idx + '-future'"
                                                                :id="'cgp-future-' + idx"
                                                                v-if="cgp.period_bar[1] > 0"
                                                                :class="'cgp cgp-future'"
                                                                :value="cgp.period_bar[1]">
                                                    {{ cgp.period[1] }}
                                                </b-progress-bar>
                                            </template>

                                        </b-progress>

                                        <template v-for="(cgp, idx) in cgpList">
                                            <!-- Tooltip 已完成區域 -->
                                            <b-tooltip  :key="idx"
                                                        :target="'cgp-' + idx"
                                                        v-if="cgp.period_bar[0] > 0"
                                                        placement="bottom">
                                                <div class="tooltip-title">{{ cgp.name }}</div>
                                                <div class="tooltip-title-sub"> {{ cgp.period[0] + ' ' + $t('u.days') }} </div>
                                                <div class="tooltip-description" v-if="cgp.definition">{{ cgp.definition }}</div>
                                            </b-tooltip>
                                            <!-- Tooltip 未來區域的 -->
                                            <b-tooltip  :key="idx + '-future'"
                                                        :target="'cgp-future-' + idx"
                                                        v-if="cgp.period_bar[1] > 0"
                                                        placement="bottom">
                                                <div class="tooltip-title">{{ cgp.name }}</div>
                                                <div class="tooltip-title-sub">
                                                    {{ $t('menu.days_left') }}：
                                                    <template v-if="cgp.tolerance">
                                                        {{ ( cgp.period[1] - cgp.tolerance > 0 ? cgp.period[1] - cgp.tolerance
                                                        : 0 ) }} ~ {{ cgp.period[1] + cgp.tolerance }} {{ $t('u.days') }}
                                                    </template>
                                                    <template v-else>
                                                        {{ cgp.period[1] + ' ' + $t('u.days') }}
                                                    </template>
                                                </div>
                                                <div class="tooltip-description" v-if="cgp.definition">{{ cgp.definition }}</div>
                                            </b-tooltip>
                                        </template>

                                    </div>

                                </b-col>
                            </b-row>

                        </b-tab>

                        <!-- 感測器資訊 -->
                        <b-tab class="info-tab" :title="$t('menu.device_information')">
                            <h5>
                                {{ $t('menu.devices_in_cropping_season') }}
                                <b-badge class="badge-small">{{ cropperiod_detail.devices.length }}</b-badge>
                            </h5>
                            <div v-for="(device, idx_d) in cropperiod_detail.devices" :key="idx_d" class="device-info">
                                <a class="device-title" @click="$tools.ui.goToID( id_device_chart + device.hashid, user_browser )">
                                    <i :class="$tools.style.classIcon(device.type, 'block-text')"></i>{{ device.nickname }}<span
                                        class="device-hashid">{{ device.hashid }}</span>
                                </a>

                                <div class="device-sensor" v-if="device.visualization">
                                    <div v-for="(ds, idx_ds) in device.visualization" :key="idx_ds" class="device-sensor-blocks">
                                        {{ $t('sensor.' + ds) }}<div class="device-unit" v-html="$t('sensor.u_' + ds)"></div>
                                    </div>
                                </div>

                                <div class="device-description">{{ device.description }}</div>
                            </div>
                        </b-tab>

                    </b-tabs>


                </b-col>
            </b-row>
            <!--/.row-->



            <!-- 期作已設定結束日期，且已經過了一天 -->
            <div v-if="cropperiod_detail.end_date && $tools.date.countDays(cropperiod_detail.end_date) > 0">
                <div class="info-block">
                    <i class="fa fa-archive block-text"></i>【 {{ cropperiod_detail.name }} 】 {{ $t('other.finished_to_history') }}
                </div>
            </div>
            <div v-else id="dashboard">
                <div v-for="(device, idx_d) in cropperiod_detail.devices" :key="idx_d + '-draw-dashboard'" :id="id_device_chart + device.hashid">
                    <div v-if="device.status == 'active' || device.status == 'shipped'">
                        <template v-if="device.type == 'camera'">
                            <DevicePhoto
                                :key="idx_d + '-photo'"
                                :device="device"
                                :cropperiod_uuid="cropperiod_detail.uuid"
                                :cropperiod_name="cropperiod_detail.name"
                                :timezone="cropperiod_detail.project_timezone"
                                :autoUpdate="true">
                            </DevicePhoto>
                        </template>
                        <template v-else>
                            <DeviceChart
                                :key="idx_d + '-device'"
                                :device="device"
                                info_type="realtime"
                                :showToolbox="true"
                                :cropperiod_uuid="cropperiod_detail.uuid"
                                :cropperiod_name="cropperiod_detail.name"
                                :sensor_rules="sensorRules"
                                :timezone="cropperiod_detail.project_timezone">
                            </DeviceChart>
                        </template>
                    </div>

                </div>
            </div>

            <!-- 放在最下方 -->
            <ButtonTopRight
                :dropdown="dropdownList"
                :expand_button="true"
                :compress_button="false"
                :expand_element_id="undefined"
            ></ButtonTopRight>

        </div>
        <div v-else>
            <NoData></NoData>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import NoData from '@/views/components/NoData'
import AgriLoading from '@/views/components/AgriLoading'
import ButtonTopRight from '@/views/components/Button_TopRight'
// import ButtonFullScreen from '@/views/components/Button_FullScreen'
import UnitConvertorArea from '@/views/components/UnitConvertor_Area'

import DeviceChart from './components/Chart_Device'
import DevicePhoto from './components/Photo_Device'


export default {
    components: {
        NoData,
        AgriLoading,
        ButtonTopRight,
        // ButtonFullScreen,
        UnitConvertorArea,
        DeviceChart,
        DevicePhoto,
    },
    data: function () {
        return {
            loading: false,
            tabIndex: [0, 0],
            id_device_chart: 'device-chart-block-',
            sensorRules: {},

            showUI: {
                dashboard_stages: false,
            },

            cropperiod_detail: undefined,
            cgpData: undefined,
            cgpList: undefined,

            deferredPrompt: undefined,
        }
    },
    mounted ()
    {
        this.get_Cropperiod();
    },
    computed: {
        ...mapState({
            'user_browser': state => state.user.userBrowser,
            'user_admin': state => state.user.is_admin,
            'language': state => state.user.language,
        }),

        projID ()
        {
            return this.$route.params.projectID;
        },
        cropperiod_UUID ()
        {
            return this.$route.params.cropperiod_uuid;
        },

        dropdownList ()
        {
            let _list = [{
                    icon: 'fa fa-paw',
                    name_code: 'go_top',
                    name: 'Top',
                    href: '#page-top',
                },
                // {
                //   icon: 'wi wi-raindrop',
                //   name_code: 'weather_forecast',
                //   name: 'Forecast',
                //   href: '#yahoo-weather',
                // },
            ]

            if (this.cropperiod_detail.devices && this.cropperiod_detail.devices.length > 0) {
                this.cropperiod_detail.devices.forEach(_d => {
                    _list.push({
                        icon: this.$tools.style.classIcon(_d.type),
                        name: _d.nickname,
                        href: this.id_device_chart + _d.hashid,
                        // href: '#' + this.id_device_chart + _d.hashid,
                    });
                })
            }

            return _list
        },


        /**
            *  顯示進入下一個階段的天數
            *  預設為直接計算的 day_next 結果，
            *  如果有誤差值 ( > 0 ) 就顯示加減天數 min ~ max，
            *  min 最小為 0
            */
        daysToNextStage() {
            let _day_count = this.cropperiod_detail.stage.day_next;
            let _show_range = '' + _day_count;

            if (this.cgpList) {
                this.cgpList.forEach(_cgp => {
                    if (_cgp.code == this.cropperiod_detail.stage.next_growth_stage) {
                        if (_cgp.tolerance > 0) {
                            let _min = (_day_count - _cgp.tolerance > 0 ? _day_count - _cgp.tolerance : 0)
                            let _max = _day_count + _cgp.tolerance
                            _show_range = _min + '~' + _max
                        }
                    }
                })
            }
            return _show_range;
        },

    },
    watch: {
        // 偵測到 [ 語言 ] 變動就更新圖表
        language ()
        {
            this.get_Cropperiod();
        },
    },
    methods: {

        get_Cropperiod_Stages ()
        {
            this.cgpList = undefined;
            const options = {
                method: 'GET',
                url: this.$config.getAPI_URL('Cropperiod_Public_Stages', { cropperiodUUID: this.cropperiod_UUID }),
            }
            this.$http(options)
                .then(res => {

                    let _result_data = res.data
                    this.$store.commit('cropperiod/setGrowthPeriodBar', _result_data)

                    this.cgpData = _result_data;
                    this.cgpList = _result_data.growth_period;
                })
                .catch(err => {})
        },

        get_Cropperiod ()
        {
            this.loading = true
            const options = {
                method: 'GET',
                url: this.$config.getAPI_URL('Cropperiod_Public_Detail', { cropperiodUUID: this.cropperiod_UUID }),
            }
            this.$http(options)
                .then(res => {
                    this.loading = false

                    let _cropperiod_data = res.data.cropperiod
                    if ( _cropperiod_data )
                    {
                        _cropperiod_data.start_date = this.$tools.date.dateTimeZone( _cropperiod_data.start_date, _cropperiod_data.project_timezone );
                        _cropperiod_data.end_date   = this.$tools.date.dateTimeZone( _cropperiod_data.end_date,   _cropperiod_data.project_timezone );

                        // 計算種植日數
                        let _count_plantingDays = this.$tools.date.countDays( _cropperiod_data.start_date, _cropperiod_data.end_date, _cropperiod_data.project_timezone )
                        _cropperiod_data.count_plantingDays = ( _count_plantingDays < 0 ? 0 : _count_plantingDays )

                        // 取 crop_code 前四碼為 [ 作物代碼 ]
                        if (_cropperiod_data.cropinfo.crop_code)
                        {
                            let _full_code = _cropperiod_data.cropinfo.crop_code
                            _cropperiod_data.cropinfo.full_code    = _full_code;
                            _cropperiod_data.cropinfo.crop_code    = _full_code.slice(0,4);
                            _cropperiod_data.cropinfo.crop_info_id = _cropperiod_data.cropinfo.id;
                        }
                        if (_cropperiod_data.pic)  _cropperiod_data.pic  += '?' + Math.random();
                        if (_cropperiod_data.boundary)  _cropperiod_data.boundary  += '?' + Math.random();

                        // 對裝置做排序
                        _cropperiod_data.devices = this.$tools.ui.reorderDevice( _cropperiod_data.devices );

                        // 根據專案版本判斷是否繪製生長階段圖
                        this.check_ShowUI( _cropperiod_data.project_service_level )
                    }
                    this.cropperiod_detail = _cropperiod_data
                })
                .catch(err => {
                    this.loading = false
                })
        },

        check_ShowUI (_serviceLevel)
        {
            this.showUI.dashboard_stages = this.$tools.service.check_ShowUI( _serviceLevel, 'dashboard_stages' )
            if ( this.showUI.dashboard_stages )
            {
                this.get_Cropperiod_Stages();
            }
            else
            {
                this.cgpList = undefined;
            }
        },

    },

}

</script>

<style lang="scss" scoped>
.info-tab {
    min-height: 150px;
}



.tooltip-inner {
    font-size: 1rem !important;
}

.device-hashid {
    font-size: 0.7rem;
    margin-left: 5px;
}

.device-info {
    margin-bottom: 8px;
}

.device-title {
    display: inline-block;
    margin-left: -5px;
    margin-bottom: 5px;
    padding: 3px 12px 3px 8px;
    color: black;
    background-color: #eceaea;
    border-radius: 20px;

    &:hover {
        cursor: pointer;
        color: #5bcfcf !important;
        background-color: #2f353a; //#76ad82;
        text-decoration: none;

        i {
            color: #f1d118;
        }
    }
}
.device-title-admin
{
    display: inline-block;
    margin-left: -5px;
    margin-right: 10px;
    margin-bottom: 5px;
    padding: 3px 12px 3px 8px;
    color: #5bcfcf !important;
    background-color: #2f353a; //#76ad82;
    text-decoration: none;
    border-radius: 20px;

    i {
        color: #f1d118;
    }
}

.device-sensor {
    display: inline-block;
    margin-left: 20px;
    font-size: 0.85rem;
}

.device-sensor-blocks {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 1px 6px;
    background-color: #f5d38a;
    border-radius: 2px;
}

.device-unit {
    display: inline-block;
    margin-left: 5px;
    font-size: 0.7rem;
    color: #1f9270;
}

.device-description {
    display: inline-block;
    margin-left: 20px;
}

</style>
